import { slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldGroup } from '../Form/FieldGroup.js';
import { FloatingLabelFormField } from '../../material/FloatingLabelFormField.js';
import { i18n } from '../../i18n/translate.js';
import { IconCategoryValue } from '../icon-category-value/index.js';
import { Button } from '../Button/index.js';
import debounce from 'lodash/debounce.js';
import { BaseFilter } from './base-filter/component.js';
import { DateTimePickerControl } from '../date-time-picker-control/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';

var DateFilter = function DateFilter(props) {
  var onChange = props.onChange,
      value = props.value,
      fromDateCaption = props.fromDateCaption,
      toDateCaption = props.toDateCaption,
      isWrapper = props.isWrapper,
      tileDisabled = props.tileDisabled;

  var _useState = useState(value || null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var _useState3 = useState(function () {
    return value !== null && value !== void 0 && value.from_date ? new Date(value.from_date) : undefined;
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      minDate = _useState4[0],
      setMinDate = _useState4[1];

  var _useState5 = useState(function () {
    return value !== null && value !== void 0 && value.to_date ? new Date(value.to_date) : undefined;
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      maxDate = _useState6[0],
      setMaxDate = _useState6[1];

  var dataAttributes = pickDataAttributes(props, 'date-filter');
  var setValidations = useCallback(function (val) {
    var from_date = val !== null && val !== void 0 && val.from_date ? new Date(val.from_date) : undefined;
    var to_date = val !== null && val !== void 0 && val.to_date ? new Date(val.to_date) : undefined;
    setMinDate(from_date);
    setMaxDate(to_date);
  }, []);
  var setValue = useCallback(function (newValue) {
    var debouncedSet = debounce(function (value) {
      setSelectedValue(value);
      setValidations(value);
    }, 500);
    debouncedSet(newValue);
  }, [setSelectedValue, setValidations]);
  useEffect(function () {
    if (value !== selectedValue) {
      setValue(value);
    }
  }, [value, setValue, selectedValue]);
  useEffect(function () {
    setValidations(selectedValue);
  }, [selectedValue, setValidations]);
  useEffect(function () {
    if (!value || Object.keys(value).length === 0) {
      setSelectedValue(null);
    }
  }, [value]);

  var clearFilter = function clearFilter() {
    setSelectedValue(null);

    if (typeof onChange === 'function') {
      onChange(null);
    }
  };

  var handleValueChange = function handleValueChange(val) {
    setSelectedValue(function (prevSelectedValue) {
      return _objectSpread2(_objectSpread2({}, prevSelectedValue), val);
    });

    if (typeof onChange === 'function') {
      onChange(val);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldGroup, {
    className: "date-filter"
  }, /*#__PURE__*/React.createElement(BaseFilter, _extends({}, props, {
    value: selectedValue
  }, dataAttributes), /*#__PURE__*/React.createElement(FieldGroup, {
    onValueChange: handleValueChange,
    data: selectedValue
  }, /*#__PURE__*/React.createElement(FloatingLabelFormField, {
    caption: fromDateCaption,
    className: "icon-label",
    name: "from_date"
  }, /*#__PURE__*/React.createElement(DateTimePickerControl, {
    tileDisabled: tileDisabled && tileDisabled.fromDate,
    timeFormat: false,
    valueOverride: true,
    maxDate: maxDate
  }))), /*#__PURE__*/React.createElement(IconCategoryValue, {
    icon: "arrow-right"
  }), /*#__PURE__*/React.createElement(FieldGroup, {
    onValueChange: handleValueChange,
    data: selectedValue
  }, /*#__PURE__*/React.createElement(FloatingLabelFormField, {
    caption: toDateCaption,
    className: "icon-label",
    name: "to_date"
  }, /*#__PURE__*/React.createElement(DateTimePickerControl, {
    tileDisabled: tileDisabled && tileDisabled.toDate,
    timeFormat: false,
    valueOverride: true,
    minDate: minDate
  }))), selectedValue && (selectedValue.from_date || selectedValue.to_date) && !isWrapper ? /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilter,
    style: "link",
    className: "clear-filter",
    "data-action": "clear-filter",
    icon: "xmark",
    label: i18n.t('Clear Filter')
  }) : null)));
};

DateFilter.propTypes = {
  fromDateCaption: PropTypes.string,
  isWrapper: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tileDisabled: PropTypes.shape({
    fromDate: PropTypes.func,
    toDate: PropTypes.func
  }),
  toDateCaption: PropTypes.string,
  value: PropTypes.object
};
DateFilter.defaultProps = {
  fromDateCaption: i18n.t('From Date'),
  isWrapper: false,
  toDateCaption: i18n.t('To Date')
};
DateFilter.displayName = 'DateFilter';
export { DateFilter };